import "./Common_Expert_Login_Details.css";
import React, { useState } from "react";
import Common_Call_Button from "../common-send-button/common-call-button/Common_Call_Button";
import Subscription_Needed_Lottie_Modal from "../subscription-needed-lottie-modal/Subscription_Needed_Lottie_Modal";

const Common_Login_Expert_Details = ({ data, onCallClick }) => {
  const [showModal, setShowModal] = useState(false);

  if (!data) return null;
  const handleCallClick = (e) => {
    setShowModal(true);

    if (onCallClick) {
      onCallClick(e);
    }
  };

  return (
    <div className="expert-login-card">
      <div className="expert-login-card__container">
        <div className="expert-login-card__body">
          <div className="wallet-container">
            <i className="fa-solid fa-wallet"></i>
          </div>

          <div className="expert-login-card__info-grid">
            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">Name :-</span>
              <span className="expert-login-card__value">
                {data.name || data.material}
              </span>
            </div>

            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label mobile-label">
                Mobile No :-
              </span>
              <span className="expert-login-card__value">
                {data.mobile_no || data.material}
              </span>
            </div>

            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">Profession :-</span>
              <span className="expert-login-card__value">
                {data.profession || data.material}
              </span>
            </div>
            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">Description :-</span>
              <span className="expert-login-card__value">
                {data.description || data.material}
              </span>
            </div>
            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">Work Start :-</span>
              <span className="expert-login-card__value">
                {data.work_start || data.material}
              </span>
            </div>
            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">Timeline :-</span>
              <span className="expert-login-card__value">{data.timeline}</span>
            </div>
            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">State :-</span>
              <span className="expert-login-card__value">{data.state}</span>
            </div>
            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">District :-</span>
              <span className="expert-login-card__value">{data.district}</span>
            </div>
            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">Taluka :-</span>
              <span className="expert-login-card__value">{data.taluka}</span>
            </div>
            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">Area :-</span>
              <span className="expert-login-card__value">{data.area}</span>
            </div>
          </div>

          <div className="expert-login-card__footer">
            <Common_Call_Button onClick2={handleCallClick} />
          </div>
        </div>
      </div>

      <Subscription_Needed_Lottie_Modal
        showSubscription={showModal}
        handleSubscriptionClose={() => setShowModal(false)}
      />
    </div>
  );
};

export default Common_Login_Expert_Details;
